<script setup lang="ts">

import { computed, useTemplateRef } from 'vue';
import { useElementSize } from '@vueuse/core';

type Props = {
    slotWidth: number
}

const container = useTemplateRef( 'container' );
const wrapper = useTemplateRef( 'wrapper' );

const { slotWidth } = defineProps<Props>();
const { width } = useElementSize( container );
const { height } = useElementSize( wrapper );

const scale = computed( () => width.value / slotWidth );
const slotWidthValue = computed( () => `${slotWidth}px` );
const containerHeight = computed( () => `${height.value * scale.value}px` );

</script>

<style lang="scss" scoped>
    .container-height
    {
        height: v-bind( 'containerHeight' );
    }
    .wrapper-scale
    {
        width: v-bind( 'slotWidthValue' );
        transform: scale( v-bind( 'scale' ) );
    }
</style>

<template>

    <div ref="container" 
        class="w-full container-height flex justify-center items-center">
        <div ref="wrapper" 
            class="absolute wrapper-scale">
            <slot />
        </div>
    </div>

</template>